import { Box, useMediaQuery } from "@mui/material";

import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";

import { AdminMainContainer } from "@modules/administration/components/AdminMainContainer";
import { ErrorPage, LoadingPage } from "components/pages";
import { useGetZones } from "hooks/useGetZones";

import { ZoneSidebar } from "./components/ZoneSidebar";

export function AdministrationScreen() {
  const { t } = useTranslation();

  const { zones, isLoading, isError } = useGetZones();

  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down("md"));

  if (isLoading) {
    return <LoadingPage />;
  }

  if (isError) {
    return (
      <ErrorPage
        title={t("Failed to load data")}
        buttonOnClick={location.reload}
        buttonText={t("Try again")}
      />
    );
  }

  if (isSmall) {
    return <AdminMainContainer zones={zones} />;
  }

  return (
    <Box display={"flex"}>
      <ZoneSidebar zones={zones} />
      <AdminMainContainer zones={zones} />
    </Box>
  );
}
